import api from './api';

/**
 * Get all packaging materials
 */
export const getPackagingMaterials = async (params = {}) => {
  try {
    const response = await api.get('/admin/packaging-materials/', {
      params,
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to fetch packaging materials');
  }
};

/**
 * Get packaging material by ID
 */
export const getPackagingMaterial = async (id) => {
  try {
    const response = await api.get(`/admin/packaging-materials/${id}/`, {
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to fetch packaging material');
  }
};

/**
 * Create packaging material
 */
export const createPackagingMaterial = async (data) => {
  try {
    const response = await api.post('/admin/packaging-materials/', data, {
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to create packaging material');
  }
};

/**
 * Update packaging material
 */
export const updatePackagingMaterial = async (id, data) => {
  try {
    const response = await api.patch(`/admin/packaging-materials/${id}/`, data, {
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to update packaging material');
  }
};

/**
 * Delete packaging material
 */
export const deletePackagingMaterial = async (id) => {
  try {
    const response = await api.delete(`/admin/packaging-materials/${id}/`, {
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to delete packaging material');
  }
};
